import {Api, HTTPMethod, buildExport} from "@next/apiconfig"
import env from "../../env"

const {REACT_APP_API_BASEURL_ADVERTS} = env

export class AdvertsApi implements Api {
    baseURL = `${REACT_APP_API_BASEURL_ADVERTS}`
    version = "v1"
    endpoints = {
        getAdsConfig: {
            routeDefinition: `${env.REACT_APP_SERVE_PATH_PREFIX}/adverts/:urlPath`,
            getLocalURL: () => `${env.REACT_APP_SERVE_PATH_PREFIX}/adverts/:urlPath`,
            getRemoteURL: (urlPath: string) => `/configurations${urlPath}`,
            method: HTTPMethod.get,
        },
    }
}

const advertsApi = new AdvertsApi()
export default (endpoint: keyof typeof advertsApi.endpoints) => buildExport(advertsApi, endpoint)
